module.exports = __webpack_public_path__ + "media/images/wedding/thumb/15-84044c40e79f4c470141c30ffabadc4f.jpg";